import styled from "styled-components";

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: right;
`;
